import axios from 'axios';

// use the env var if it's available, and trim any tailing / to prevent double // in baseURL
const apiCoreHost = (process.env.CORE_API_URL || '').trimRight();

const requestHandler = (req: Object) => req as any;
const coreApiInstance = axios.create({
    headers: { Accept: 'application/json' },
    baseURL: `${apiCoreHost}/api/`,
});

coreApiInstance.interceptors.request.use((request) => requestHandler(request));

export default coreApiInstance;
